import { render, staticRenderFns } from "./collsoissueview.vue?vue&type=template&id=2bdc453b&scoped=true&"
import script from "./collsoissueview.vue?vue&type=script&lang=js&"
export * from "./collsoissueview.vue?vue&type=script&lang=js&"
import style0 from "./collsoissueview.vue?vue&type=style&index=0&id=2bdc453b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdc453b",
  null
  
)

export default component.exports